import axiosInstance from "./axiosInstance";

export * from "./aspekAdministrasiApi";
export * from "./aspekKeuanganApi";
export * from "./aspekOperasionalApi";
export * from "./beritaApi";
export * from "./eventApi";
export * from "./pegawaiApi";
export * from "./daftarAsetApi";
export * from "./devidenApi";

export async function getData(
  startYear='',
  endYear='',
  type='',
  startMonth='',
  endMonth='',
  perusahaanId='',
  url=''
) {
  return axiosInstance.get(
    `/indikator-kesehatan/${url}?startYear=${startYear}&endYear=${endYear}&type=${type}&startMonth=${startMonth}&endMonth=${endMonth}&perusahaanId=${perusahaanId}`
  );
}

export async function getIndikatorKesehatanAll(year, perusahaanId) {
  return axiosInstance.get(
    `indikator-kesehatan/aspek-keuangan-web?type=2&startMonth=0&endMonth=0&perusahaanId=${perusahaanId}&startYear=2021&endYear=2022`
  );
}
